<template>
    <div class="middle contentRadioavis">
        <link href="https://fonts.googleapis.com/css?family=Heebo:400,900&display=swap" rel="stylesheet">
        <div class="audioHeader">
            <img class="audioImage" :src="media_skin_image" :style="image_style">
            <div class="audioLabel" v-if="title">
                {{title}}
            </div>
        </div>
        <div class="audioContainer">
            <audio v-if="autoplay" autoplay controls="" class="audioFile" :src="file_url" :style="audio_width" />
            <audio v-else controls="" class="audioFile" :src="file_url" :style="audio_width" />
        </div>
    </div>
</template>

<script>
export default {
    name: "AudioPreview",
    props: {
        title: String,
        media_skin: String,
        file_url: String,
        autoplay: Boolean,
        preview: Boolean
    },
    computed: {
        media_skin_image() {
            if (this.media_skin) return "/img/audio/" + this.media_skin + ".png"
            return ""
        },
        audio_width() {
            if (this.preview) return 'width: 100%'
            else return ''
        },
        image_style() {
            let style = ""
            if (this.preview) style = style + 'max-height: 8em;'
            else style = style + 'max-height: 5em;'

            if (this.media_skin != 'waveform') style = style + "box-shadow: 0px 0px 20px #CCCCCC;"
            return style
        }
    }
}
</script>

<style>

.contentRadioavis {
    width: 50%;
    margin: auto;
}

.audioHeader {
    display: flex;
    margin-bottom: 1em;
}

.audioImage {
    margin-right: 1em;
    margin-left: 1em;
    border-radius: 0.5em;
}

.audioLabel {
    font-family: 'Heebo', sans-serif;
    font-weight: bold;
    font-size: 2em;
    margin-top: auto;
    margin-bottom: auto;
    margin-right: auto;
    text-transform: uppercase;
}

.audioContainer {
    display: flex;
    margin-bottom: 1em;
}

.audioFile {
    margin-bottom: auto;
    margin-top: auto;
}

</style>